import ApiModel from 'models/api-model';
import { isNullOrUndefined } from 'utils/object-utils';

const chatbotFeature = 'CHATBOT';

export class FeatureFlags extends ApiModel({
  data: {},
}) {
  processResponse({ response }) {
    return {
      data: response,
    };
  }

  get featureFlags() {
    return this.data;
  }

  // filters only chatbot feature flags by geo
  getChatbotFeatures(geo) {
    const featureFlagsByGeo = this.data[geo];
    return isNullOrUndefined(featureFlagsByGeo)
      ? []
      : featureFlagsByGeo.filter((item) => item.includes(chatbotFeature));
  }
}
